import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import { withAnalytics } from '@carvana/analytics';
import { connect } from 'react-redux';
import { getPreviousLocationPathname } from '@carvana/purchase-store/src/middleware/error/ducks/selectors';
import { CancelCurrentPurchase } from '../../../../purchase-ui/src/components/dashboard/ducks/actions';
import Error from './error';
import '@carvana/purchase-store/src/middleware/error/ducks/reducer';

const mapStateToProps = state => ({
  previousLocation: getPreviousLocationPathname(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ CancelCurrentPurchase }, dispatch);

export default compose(
  withAnalytics({
    componentName: 'Error',
    enableComponentTracking: true
  }),
  connect(mapStateToProps, mapDispatchToProps)
)(Error);
